import { render, staticRenderFns } from "./LetPeepsKnow.vue?vue&type=template&id=39656ba0&"
import script from "./LetPeepsKnow.vue?vue&type=script&lang=js&"
export * from "./LetPeepsKnow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports